import React, { Component } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { addOneBreadcrumbPath, keepSecondNavBreadcrumb } from '@/reducers/home/actions';
import { XOKButton, XCancelButton, XInput, XSelect, } from '@/components/xqxc_ui';
import { SearchBox, SearchItem } from '@/components/Layout';
import InfoTableBox from './components/InfoTableBox';
import InfoEdit from './modal/InfoEdit';
import model from '@/reducers/system/operatingrule/model';

class AutonymAudit extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,//路由对象
        addOneBreadcrumbPath: PropTypes.func, // 新增3级面包屑导航信息
        keepSecondNavBreadcrumb: PropTypes.func, // 保持2级面包屑导航信息

        evaluateInfos: PropTypes.object,
        getEvaluateInfos: PropTypes.func,//评价内容列表action
        evaluateTypes: PropTypes.array,
        getEvaluateTypes: PropTypes.func,//评价星级列表action
    }


    state = {
        renderModal: 'default',
        modalParams: {},
        label: '',
        typeItem: {},
    }

    componentDidMount() {
        const { keepSecondNavBreadcrumb, getEvaluateTypes } = this.props;
        keepSecondNavBreadcrumb();
        getEvaluateTypes();//评价星级列表
    }

    // 查询触发
    onSearch = (useCache) => {
        const { label, typeItem, pageNum, pageSize } = this.state;
        this.searchCache = {
            label, appraiseTypeId: typeItem.id,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getEvaluateInfos(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    onReset = () => {
        this.setState({ label: '', typeItem: {} }, () => {
            KeepAlive.saveResetFunc(this.onSearch); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    //分页改变
    onPageChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this.onSearch('useCache');
        });
    }

    //表格操作
    onTableOperate = (id, record) => {
        this.setState({ renderModal: 'editInfo', modalParams: record });
    }

    //关闭弹框
    onClose = (status) => {
        this.setState({ renderModal: 'default', modalParams: {} }, () => {
            status && this.onSearch('useCache');
        });
    }

    render() {
        const { evaluateInfos, evaluateTypes } = this.props;
        const { label, typeItem, renderModal, modalParams } = this.state;

        const modalObject = {
            editInfo: <InfoEdit
                onClose={this.onClose}
                modalParams={modalParams} />,
            default: null
        };

        return <KeepAlive id='2' render={(state) => {
            if (!this.state.__aliveInit) {
                this.setState({ ...state, __aliveInit: true }, () => {
                    this.onSearch('useCache'); // 【第1步：调用查询接口初始化数据】
                });
            }
        }}>
            <div className={styles.flexBoxContainer}>
                <SearchBox>
                    <SearchItem>
                        <XInput
                            label='类型标签'
                            placeholder='请输入'
                            bindThis={this}
                            bindName='label'
                            value={label}
                            showLength={false}
                            maxLength={100}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='评价星级'
                            placeholder='请选择评价星级'
                            renderData={evaluateTypes}
                            bindThis={this}
                            bindName='typeItem'
                            dataIndex='name'
                            keyIndex='id'
                            value={typeItem.name}
                            showSearch={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            label='查询'
                            onClick={this.onSearch}
                        />
                        <XCancelButton
                            label='重置'
                            onClick={this.onReset}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            style={{ width: 120, marginLeft: 20 }}
                            label='新建评价标签'
                            onClick={() => {
                                this.setState({ renderModal: 'editInfo', modalParams: {} });
                            }}
                        />
                    </SearchItem>
                </SearchBox>
                <InfoTableBox
                    evaluateInfos={evaluateInfos}
                    onTableOperate={this.onTableOperate}
                    onPageChange={this.onPageChange}
                />
                {modalObject[renderModal]}
            </div>
        </KeepAlive>;
    }
}

export default connect(state => ({
    evaluateInfos: state.operatingrule.evaluateInfos,
    evaluateTypes: state.operatingrule.evaluateTypes,
}), {
    addOneBreadcrumbPath,
    keepSecondNavBreadcrumb,
    ...model.actions
})(AutonymAudit);